export const getInterventionZoneByExecutionId = (interventionZones, executionId) => interventionZones
  .find(iz => iz.interventions
    .some(i => i.executions
      .some(e => e.id === executionId)));